import {createAsyncThunk} from "@reduxjs/toolkit";
import AuthService from "../../services/AuthService";
import {putAccessTokenToStorage, putTokensToStorage} from "../utils/functions";

export const tgWebAppSignInThunk = createAsyncThunk(
    'auth/tgWebAppSignIn',
    async ({ auth_data }, { rejectWithValue }) => {
        try {
            const { data } = await AuthService.tgWebAppSignIn(auth_data)
            putTokensToStorage(data.access_token, data.refresh_token)

            return data
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

export const sendPhoneOtpThunk = createAsyncThunk(
    'auth/sendPhoneOtp',
    async ({ phone_number, platform }, { rejectWithValue }) => {
        try {
            const { data } = await AuthService.sendPhoneOtp(phone_number, platform)
            return data
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

export const verifyPhoneOtpThunk = createAsyncThunk(
    'auth/verifyPhoneOtp',
    async ({ phone_number, otp }, { rejectWithValue }) => {
        try {
            const { data } = await AuthService.verifyPhoneOtp(phone_number, otp)
            putAccessTokenToStorage(data.access_token)
            return data
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

export const viewerSignInThunk = createAsyncThunk(
    'auth/viewerSignIn',
    async ({ login, password }, { rejectWithValue }) => {
        try {
            const { data } = await AuthService.viewerSignIn(login, password)
            putTokensToStorage(data.access_token, data.refresh_token)
            return data
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

export const checkAuthWithHeaderThunk = createAsyncThunk(
    'auth/checkAuthWithHeader',
    async ({ refreshToken }, { rejectWithValue }) => {
        try {
            const {data} = await AuthService.refreshWithHeader(refreshToken)
            putTokensToStorage(data.access_token, data.refresh_token)
            return data
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

export const checkAuthWithCookieThunk = createAsyncThunk(
    'auth/checkAuthWithCookie',
    async ({ rejectWithValue }) => {
        try {
            const { data } = await AuthService.refreshWithCookie()

            return data
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

export const signOutThunk = createAsyncThunk(
    'auth/signOut',
    async ({ rejectWithValue }) => {
        try {
            const { data } = await AuthService.signOut()

            return data
        } catch (error) {
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)
